import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class RentDeposit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rentDepositDetails: this.props.rentDepositDetails,
    };
    console.log(Object.values(this.state.rentDepositDetails)[0]);
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {Object.keys(this.state.rentDepositDetails).map(function (
              key,
              index
            ) {
              return this.state.rentDepositDetails[key].map(function (
                rent,
                index
              ) {
                return (
                  <div className="container-fluid p-0">
                    <div className="row prospectAccordion">
                      <div className="col-lg-12 p-0">
                        <Accordion.Item eventKey={index}>
                          <Accordion.Header>
                            {`Period `}
                            {` `}
                            {rent.period}
                            {` `}
                            {`( Period Term - ${
                              rent.periodTermYY == "" ? "0" : rent.periodTermYY
                            }Y -${
                              rent.periodTermMM == "" ? "0" : rent.periodTermMM
                            }M -${
                              rent.periodTermDD == "" ? "0" : rent.periodTermDD
                            }D )`}
                            {` -`}
                            {` `}
                            {rent.rentDepositNature}
                            {` - `}
                            {`From ${leaseDateFormat(rent.fromDate)}`}
                            {` `}
                            {`To ${leaseDateFormat(rent.toDate)}`}
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="container-fluid">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.period}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period Term{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.periodTermYY == ""
                                          ? "0"
                                          : rent.periodTermYY}
                                        {"-"}
                                        {rent.periodTermMM == ""
                                          ? "0"
                                          : rent.periodTermMM}
                                        {"-"}
                                        {rent.periodTermDD == ""
                                          ? "0"
                                          : rent.periodTermDD}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Rent Deposit Nature (RDEP){" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.rentDepositNature}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        From <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {leaseDateFormat(rent.fromDate)}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        To <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {leaseDateFormat(rent.toDate)}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        RDEP # Months{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.months}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        RDEP Rate UOM{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.rateUOM}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        RDEP # Rate{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.rate}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        RDEP On Area{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {rent.onArea}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        RDEP Total Amount{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <label className="col-sm-7 col-form-label">
                                        {Math.round(rent.totalAmount)}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-2 col-form-label">
                                        RDEP MileStones
                                      </label>
                                      <div className="col-sm-10 slabWidthDesktop">
                                        <div
                                          className="tableContainer"
                                          style={{ padding: "15px" }}
                                        >
                                          <table className="table tableSimple tableSimpleWithNoFlex">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  Milestone Name
                                                </th>
                                                <th scope="col">Due Date</th>
                                                <th scope="col">
                                                  RDEP Milestone
                                                </th>
                                                <th scope="col">
                                                  RDEP Milestone Amount (Rs.)
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {rent.milestones.length > 0 &&
                                                rent.milestones.map(
                                                  (name, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        {name.milestoneName}
                                                      </td>
                                                      <td>
                                                        {leaseDateFormat(
                                                          name.dueDate
                                                        )}
                                                      </td>
                                                      <td>
                                                        {Math.round(
                                                          name.milestonePercent
                                                        )}
                                                        {rent.milestones[index]
                                                          .milestoneType ==
                                                        "RDEP Percent"
                                                          ? " %"
                                                          : " Months"}
                                                      </td>
                                                      <td>
                                                        {Math.round(
                                                          name.amount
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </div>
                    </div>
                  </div>
                );
              },
              this);
            },
            this)}
          </Accordion>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Notes
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.rdNotes}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(RentDeposit);
